import { MainMarketingBlocksType, MainMarketingColorSchemeType } from 'types/common';

const mainMarketingBlocksColorSchemes: { [key in MainMarketingBlocksType]: MainMarketingColorSchemeType } = {
  RedBox: 'red',
  GreenBox: 'green',
  BlueBox: 'blue',
};

export default mainMarketingBlocksColorSchemes;
